import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { FiCheckCircle } from "react-icons/fi";
import styles from "./RegistrationCompletionModal.module.scss";

const RegistrationCompletionModal = ({
  open,
  onClose,
  onContinue,
  onGoToDashboard,
  variant = "complete",
}) => {
  const handleContinue = onContinue || onGoToDashboard || onClose;
  const isWelcome = variant === "welcome";

  const handleClose = (event, reason) => {
    // This modal is a required registration step; only the CTA should advance it.
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    onClose?.();
  };

  return (
    <div
      className={`${styles["modal-backdrop"]} ${isWelcome ? styles["modal-backdrop--welcome"] : ""}`}
      style={{ display: open ? "flex" : "none" }}
    >
      <div
        className={`${styles["modal-wrapper"]} ${isWelcome ? styles["modal-wrapper--welcome"] : ""}`}
      >
        <Dialog
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backgroundColor: isWelcome
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(0, 0, 0, 0.12)",
              backdropFilter: "blur(15px)",
            },
          }}
          maxWidth={isWelcome ? false : "xs"}
          fullWidth
          PaperProps={{
            className: `${styles["modal-paper"]} ${isWelcome ? styles["modal-paper--welcome"] : ""}`,
          }}
        >
          <DialogContent className={styles["modal-content"]}>
            {isWelcome ? (
              <>
                <FiCheckCircle
                  aria-hidden="true"
                  className={styles["modal-icon"]}
                  strokeWidth={1.5}
                />
                <Typography className={styles["modal-title"]}>
                  Welcome to Kewordal
                </Typography>
                <Typography className={styles["modal-copy"]}>
                  Explore, create, collaborate, and level up your learning with
                  your new account.
                </Typography>
              </>
            ) : (
              <>
                <Typography className={styles["modal-title"]}>
                  Complete Your Registration
                </Typography>
                <Typography className={styles["modal-copy"]}>
                  To access all features, please complete your registration by
                  providing the required information.
                </Typography>
              </>
            )}
            <Button
              onClick={handleContinue}
              variant="contained"
              color="primary"
              className={styles["modal-cta"]}
            >
              {isWelcome ? "Start Exploring" : "Complete Registration"}
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default RegistrationCompletionModal;
